import { atom } from 'jotai';

export default interface DashSummary { 
  environSum: EnvironSum;
  powerSum: PowerSum;
}

export type EnvironSum = {
  minTempF: number;
  maxTempF: number;
  TempF: number;
  minHumidity: number;
  maxHumidity: number;
  Humidity: number;
  WindMax: number;
  WindAvg: number;
  WindDir: number;
  WindDirStr: string;
}

export type PowerSum = {
  totalSolarKwh: number;
  totalLoadKwh: number;
  totalImportedKwh: number;
  totalExportedKwh: number;
  DayPeak: number;
  PeakTime: string;
}

export const dashSummaryAtom = atom<DashSummary>({
  environSum: {
    minTempF: 0,
    maxTempF: 0,
    TempF: 0,
    minHumidity: 0,
    maxHumidity: 0,
    Humidity: 0,
    WindMax: 0,
    WindAvg: 0,
    WindDir: 0,
    WindDirStr: ""
  },
  powerSum: {
    totalSolarKwh: 0,
    totalLoadKwh: 0,
    totalImportedKwh: 0,
    totalExportedKwh: 0,
    DayPeak: 0,
    PeakTime: ""
  }
});